module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("快速入门")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("vux@2.x 推荐"), _c('code', [_vm._v("webpack+vue-loader")]), _vm._v("方式的开发，如果要使用"), _c('code', [_vm._v("umd")]), _vm._v("文件，请参照"), _c('router-link', {
    attrs: {
      "to": "/zh-CN/install/umd.html"
    }
  }, [_vm._v("文档")]), _vm._v("。不建议使用引入"), _c('code', [_vm._v("script")]), _vm._v("的方式进行开发，因为它会带来一系列的开发、维护、效率、部署问题。"), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Life is short, use webpack.")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("vux2 模板")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("默认为 webpack2 模板")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("使用淘宝 npm 镜像")]), _vm._v(" "), _c('h3', [_vm._v("cnpm")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("yarn")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://github.com/airyland/vux2"
    }
  }, [_vm._v("vux2")]), _vm._v(" 模板 fork 自 "), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs-templates/webpack"
    }
  }, [_vm._v("webpack")]), _vm._v(" 模板，基本和官方同步。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vue-cli -g "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("# 如果还没安装")]), _vm._v("\nvue init airyland/vux2 projectPath\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" projectPath\nnpm install --registry=https://registry.npm.taobao.org "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("# 或者 cnpm install 或者  yarn")]), _vm._v("\nnpm run dev "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("#  或者  yarn dev")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("你可以直接使用 "), _c('code', [_vm._v("cnpm")]), _vm._v(" 来加速模块下载。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("或者如果你已经用上了 "), _c('code', [_vm._v("yarn")]), _vm._v("，建议配置淘宝源：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn config "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("set")]), _vm._v(" registry https://registry.npm.taobao.org\nyarn\n")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f27e0898", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-f27e0898"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/biolerplate-169.vue
// module id = 2470
// module chunks = 465